import styled from 'styled-components';

export const SpacingDot = styled.span`
  font-size: 6px;
  color: ${({ theme }) => theme.text.gray300};
  vertical-align: middle;
  margin: 0 8px;
`;
